import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { AjaxService, FormValidationService } from '../core';
import { areEqual } from "../shared/messages"

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.less']
})
export class ResetPasswordComponent implements OnInit {

  private _resetLink: string | undefined;
  constructor(private _translateService: TranslateService,
    private _formValidationService: FormValidationService,
    private _ajaxService: AjaxService,
    private _confirmationService: ConfirmationService,
    private _route: ActivatedRoute,
    private _router: Router) { }
  resetform = new FormGroup({});
  resetmodel: any = {};
  resetoptions: FormlyFormOptions = {};
  resetfields: FormlyFieldConfig[] = [
    {
      key: 'Password',
      type: 'password',
      wrappers:['fieldWrapper'],
      templateOptions: {
        required: true
      },
      expressionProperties: {
        'templateOptions.label': this._translateService.stream('LblPassword'),
      }
    },
    {
      key: 'ConfirmPassword',
      type: 'password',
      wrappers:['fieldWrapper'],
      templateOptions: {
        required: true,
        showPswdStrength: false
      },
      validators: {
        fieldMatch: {
          expression: (control: any) => {
            const value = control.value;
            return value === control.parent.controls.Password.value
              // avoid displaying the message error when values are empty
              || (!value || !control.parent.controls.Password.value);
          },
          message: areEqual,
        },
      },
      expressionProperties: {
        'templateOptions.label': this._translateService.stream('LblConfirmPassword'),
      }
    },
  ];

  ngOnInit(): void {

    this._route.params.subscribe(params => {
      return this.resetLink = (params && params.resetLink) ? params.resetLink : undefined;
    });
  }

  get resetLink() {
    return this._resetLink || '';
  }

  set resetLink(link: string) {
    this._resetLink = link;
  }

  changePassword() {
    const value = { ...this.resetmodel };
    value['ResetLink'] = this.resetLink;
    this._formValidationService.markFormGroupTouched(this.resetform);
    if (this.resetform.valid) {
      this._ajaxService.post('/auth/resetPassword', value).subscribe((response) => {
        if (response) {
          this._confirmationService.confirm({
            message: this._translateService.instant('LblPasswordChanged'),
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              //Actual logic to perform a confirmation
              this._router.navigate(['home']);
            }
          });
        }
      });

    }
  }

}
